<template>
  <div>
    <header>
      <Header />
    </header>
    <div>
      <div id="main">
        <section class="artWorkCateTop">
          <div v-if="this.$route.path.indexOf('/organizer') >= 0" class="artWorkCateTopTitle">
            <div class="inner4">
              <h1>主催者企画</h1>
              <p class="titleSub">Exhibitions by Organizer</p>
            </div><!-- /inner4-->
          </div><!-- /photographersListTitle-->

          <div v-if="isSelected('/organizer')" class="artWorkInfo">
            <div class="inner2">
              <p class="mainTxt">
              “写真で表現するあなたの世界”をテーマとしたTwitterフォトコンテストの受賞作品展示です。4枚組限定とし、街なかで見つけた何気ない景色や、身の回りで起きた一瞬の出来事を捉えたスナップ組み写真を募集した「スナップ部門」。縦構図限定とし、旅に出たくなるような写真と共に"旅に出たくなる"キャッチフレーズを投稿文に添えて募集した「ポスター部門」。そして、単写真限定とし、“あなたの世界“を表現したポートレート写真を募集した「ポートレート部門」の３つの部門の受賞作品を展示。
              </p>
            </div><!-- /inner2-->
          </div><!-- /artWorkInfo-->

          <div v-if="isSelected('/j100v')" class="artWorkInfo">
            <div class="inner2">
              <p class="mainTxt">
              新型コロナウイルス感染症（COVID-19）の影響によって、日本を含む世界中の観光業は過去に例がない甚大な被害を受けています。日本の名勝地は、観光業により直接・間接的に支えられていることもあり、今までにないほど厳しい状況に追い込まれています。この結果、このままでは今までのような写真撮影を楽しめなくなるおそれがますます高まっています。そこで昨年に引き続き日本全国の名勝地、観光業の支援も視野に入れたフォトコンテストを開催。今年は支援の要素をより強くするため日本全国名勝地の四季写真を募集したフォトコンテスト「日本写真100景＜四季＞2021」を開催しました。
              </p>
            </div><!-- /inner2-->
          </div><!-- /artWorkInfo-->
          
          <div class="artWorkCateTopBody">
            <div class="inner2">

              <div v-if="this.$route.path.indexOf('/organizer/twitter') >= 0" class="listBlock">
                <template v-for="category of ['Twitterフォトコンテスト']">
                  <div :key="category">
                    <h2>{{category}}</h2>
                      
                      <template v-if="category == 'Twitterフォトコンテスト'">
                        <template v-for="subCategory of ['スナップ部門', 'ポスター部門', 'ポートレート部門']">
                          <template v-if="$route.path == '/organizer/twitter' || ($route.path.indexOf('/organizer/twitter/snap') >= 0 && subCategory == 'スナップ部門') || ($route.path.indexOf('/organizer/twitter/poster') >= 0 && subCategory == 'ポスター部門') || ($route.path.indexOf('/organizer/twitter/portrait') >= 0 && subCategory == 'ポートレート部門')">
                            <div :key="subCategory">
                              <h3>{{subCategory}}</h3>
                              <div class="listBlockInner twitterBlock">
                                <div v-if="winnerListBySubCategory(subCategory).length <= 0" class="comingSoon">
                                  Coming Soon
                                </div>
                                <template v-for="(winner, index) of winnerListBySubCategory(subCategory)">
                                  <div :key="winner.id" class="exhibitor" :class="{ rowLast: (index % 5 === 4)}">
                                    <div class="thumbnailImg">
                                        <router-link :to="workUrl(winner)">
                                          <img :src="winner.mainImageUrl" :alt="winner.mainImageTitle" />
                                        </router-link>
                                    </div>
                                    <h3><router-link :to="workUrl(winner)">{{ winner.name }}</router-link></h3>
                                  </div>
                                </template>
                              </div>
                            </div>
                          </template>
                        </template>
                      </template>
                    <template v-else>
                      <div class="listBlockInner">
                        <template v-for="(winner, index) of winnerListByCategory(category)">
                          <div :key="winner.id" class="exhibitor" :class="{ rowLast: (index % 5 === 4)}">
                            <div class="thumbnailImg">
                                <router-link :to="workUrl(winner)">
                                  <img :src="winner.mainImageUrl" :alt="winner.mainImageTitle" />
                                </router-link>
                            </div>
                            <h3><router-link :to="workUrl(winner)">{{ winner.name }}</router-link></h3>
                          </div>
                        </template>
                      </div><!-- /listBlockInner-->
                    </template>

                  </div>
                </template>
              </div><!-- /listBlock-->
            </div><!-- /inner2-->
          </div><!-- /photographersListBody-->
        </section><!-- /photobook-->

      </div><!-- /main-->
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['winners', 'winnersByAwardType', 'areas'])
  },
  methods: {
    isSelected (str) {
      return this.$route.path.indexOf(str) >= 0
    },
    getArtworksCode (winner) {
      if (!this.awardTypeCode || !winner) return
      return this.awardTypeCode[winner.awardType]
    },
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    },
    awardTypeList () {
      if (this.$route.path === '/organizer') {
        return [11, 12, 13, 14, 15, 16]
      }
    },
    winnerList (type) {
      return this.winners.filter((winner) => { return winner.awardType === type })
    },
    winnerListByCategory (category) {
      return this.winners.filter((winner) => {
        if (category.indexOf('Twitter') >= 0) {
          return [11, 12, 13].indexOf(winner.awardType) >= 0
        } else if (category.indexOf('Weibo') >= 0) {
          return winner.awardType === this.EnumAwardTypeWeibo
        } else {
          return winner.awardType === this.EnumAwardTypeJtg
        }
      })
    },
    winnerListBySubCategory (subCategory) {
      return this.winners.filter((winner) => {
        if (subCategory.indexOf('スナップ') >= 0) {
          return winner.awardType === this.EnumAwardTypeTwitterSnap
        } else if (subCategory.indexOf('ポスター') >= 0) {
          return winner.awardType === this.EnumAwardTypeTwitterPoster
        } else {
          return winner.awardType === this.EnumAwardTypeTwitterPortrait
        }
      })
    },
    workUrl (winner) {
      let path = ''
      if (winner.awardType == this.EnumAwardTypeTwitterPoster) {
        path = `/organizer/twitter/poster/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeTwitterSnap) {
        path = `/organizer/twitter/snap/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeTwitterPortrait) {
        path = `/organizer/twitter/portrait/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeJtg) {
        path = `/organizer/jtg/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeWeibo) {
        path = `/organizer/weibo/${winner.id}`
      }
      return path
    },
  },
  created () {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
</style>
